import {
  TREATMENTS_SYNC_REQUEST,
  TREATMENTS_SYNC_SUCCESS,
  TREATMENTS_SYNC_FAILURE,
  TREATMENTS_SYNC_RESET,
} from '../../../actions/constants/types';

const initialState = {
  areTreatmentsFetching: false,
  isFetchingComplete: false,
  messages: null,
};

function previewedImportedTreatments(state = initialState, action) {
  switch (action.type) {
    case TREATMENTS_SYNC_REQUEST:
      return {
        ...state,
        areTreatmentsFetching: true,
        isFetchingComplete: false,
      };
    case TREATMENTS_SYNC_SUCCESS:
      return {
        ...state,
        areTreatmentsFetching: false,
        isFetchingComplete: true,
        messages: action.response.data.messages,
      };
    case TREATMENTS_SYNC_FAILURE:
      return {
        ...state,
        areTreatmentsFetching: false,
        isFetchingComplete: true,
        message: action.message,
      };
    case TREATMENTS_SYNC_RESET:
      return {
        ...state,
        isFetchingComplete: false,
      };
    default:
      return state;
  }
}

export default previewedImportedTreatments;
